import { FC, useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import BlockTypeForm from './BlockTypeForm';
import GeneralForm from './GeneralForm';
import { useStore, connect } from "src/store/connect";
import DeleteBlockConfirmation from "./DeleteBlockConfirmation";
import mixpanel from "mixpanel-browser";
interface EditBlockProps {
    onRemoveBlock: () => void;
    onClose: () => void;
    targetBlock: Block;
};

const EditBlock: FC<EditBlockProps> = ({onRemoveBlock, onClose, targetBlock}) => {
    const classes = useStyles();
    const state = useStore();

    type EditBlockState = 'editing'|'changing-type'|'deleting'

    const [editBlockState, setEditBlockState] = useState<EditBlockState>('editing')

    const onGoBack = () => {
      setEditBlockState('editing')
    }

    const onGoBlockTypeForm = () => {
        setEditBlockState('changing-type')
    }

    const onChangeBlockType = (newBlockType: BlockType) => {
      state.changeBlockType(targetBlock.id, newBlockType)
    }

    const onChangeOutgoingMessage = (newOutgoingMessage: string) => {
      const updatedTargetBlock = state.flow.nodes.filter((node) => node.id === targetBlock.id)
      if (!updatedTargetBlock || updatedTargetBlock.length <= 0) {
        return
      }
      state.updateBlock(targetBlock.id, {
        ...updatedTargetBlock[0].data,
        outgoingMessage: newOutgoingMessage
      })
    }

    const onChangeVariableName = (newVariableName: string) => {
      const updatedTargetBlock = state.flow.nodes.filter((node) => node.id === targetBlock.id)
      if (!updatedTargetBlock || updatedTargetBlock.length <= 0) {
        return
      }
      const prevVariable = updatedTargetBlock[0].data.variable
      if (prevVariable) {
        state.flow.variables?.set(prevVariable.id || "", {
          ...prevVariable,
          key: newVariableName
        })
      }
      state.updateBlock(targetBlock.id, {
        ...updatedTargetBlock[0].data,
        variable: {
          ...prevVariable,
          key: newVariableName
        }
      })

      mixpanel.track('variable_set', { block_type: updatedTargetBlock[0].type})
    }

    const onChangeBackgroundCheckInput = (newBackgroundCheckInput: CheckInput) => {
      state.updateBlock(targetBlock.id, {
        ...targetBlock.data,
        backgroundCheckInput: newBackgroundCheckInput
      })
    }

    const onChangeValidationInput = (newValidationInput: ValidationInput) => {
      state.updateBlock(targetBlock.id, {
        ...targetBlock.data,
        validationInput: newValidationInput
      })
    }

    const onAddNewMultipleOption = () => {
      state.addBlock({
        parentId: targetBlock.id,
        outgoingMessage: "",
        incomingMessage: "",
        type: "placeholder"
      })
    }

    return (
      <div className={classes.root}>
        {
          editBlockState === 'editing' &&
          <GeneralForm
            onGoBlockTypeForm={onGoBlockTypeForm}
            targetBlock={targetBlock}
            onChangeOutgoingMessage={onChangeOutgoingMessage}
            onRemoveBlock={() => setEditBlockState('deleting')}
            onAddNewMultipleOption={onAddNewMultipleOption}
            onChangeVariableName={onChangeVariableName}
            onChangeBackgroundCheckInput={onChangeBackgroundCheckInput}
            onChangeValidationInput={onChangeValidationInput}
          />
        }
        {
          editBlockState === 'changing-type' &&
          <BlockTypeForm
            onGoBack={onGoBack}
            onClose={onClose}
            targetBlock={targetBlock}
            onChangeBlockType={onChangeBlockType}
          />
        }
        {
          editBlockState === 'deleting' &&
          <DeleteBlockConfirmation
            onRemoveBlock={onRemoveBlock}
            onCancel={() => setEditBlockState('editing')}
            targetBlock={targetBlock}
          />
        }
      </div>
    );
};

EditBlock.defaultProps = { };

export default connect(EditBlock);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "#ffffff",
    width: "348px",
    height: "488px",
    padding: "27px 23px 34px 26px",
    borderRadius: "8px",
    boxShadow: "0 2px 24px 0 rgba(0, 0, 0, 0.08)",
    border: "solid 1px #eff2f8",
    overflow: "auto",
  },
}));
